import React, {useState, useEffect} from "react"
import DeskSliderPanel from "./DeskSliderPanel"
import puzzleAnswerData from "../puzzleAnswerData"

function Desk(props) {
    const [deskCode] = useState(puzzleAnswerData[3].deskCode)
    const [sliderValue, setSliderValue] = useState({
        sliderOne: 2,
        sliderTwo: 2,
        sliderThree: 2,
        sliderFour: 2,
        sliderFive: 2
    })
    const [deskInput, setDeskInput] = useState("")
        
    useEffect(() => {
        setDeskInput(sliderValue.sliderOne.toString() + sliderValue.sliderTwo.toString() + sliderValue.sliderThree.toString() + sliderValue.sliderFour.toString() + sliderValue.sliderFive.toString())
    }, [sliderValue])
    
    function handleChange(event) {
        const {value, id} = event.target
        setSliderValue({
            ...sliderValue,
            [id]: value
        })
    }
    
    useEffect(() => {
        if (deskInput === deskCode) {
            const show = "on"
            const text = "There is a loud 'CLICK' as the desk drawer pops open. You take a look inside to discover..."
            const trigger = "desk"
            props.callBack(show, text, trigger)
            props.callBackCompleted("desk", true)
            props.callBackRevealClues("The Painting", "Unlocking The Desk")
        }
    }, [deskInput, deskCode, props])
    
    return (
        <div className="officeDeskWrapper">
            <h3>The desk is impeccably organized. There is nothing of interest in two of the drawers but the third drawer is locked. Above the locked drawer there is a panel of sliding switches.</h3>

            <DeskSliderPanel callBack={props.callBack} callBackCompleted={props.callBackCompleted} handleChange={handleChange} sliderValue={sliderValue}/>
        </div>
    )
}

export default Desk